// An amount in Spanish words, the way a recibo writes it: 12,345.50 → "DOCE MIL TRESCIENTOS CUARENTA Y CINCO PESOS CON 50/100".
const UNITS = ['', 'UN', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE', 'DIEZ', 'ONCE', 'DOCE', 'TRECE',
  'CATORCE', 'QUINCE', 'DIECISÉIS', 'DIECISIETE', 'DIECIOCHO', 'DIECINUEVE', 'VEINTE', 'VEINTIÚN', 'VEINTIDÓS', 'VEINTITRÉS',
  'VEINTICUATRO', 'VEINTICINCO', 'VEINTISÉIS', 'VEINTISIETE', 'VEINTIOCHO', 'VEINTINUEVE'];
const TENS = ['', '', '', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA'];
const HUNDREDS = ['', 'CIENTO', 'DOSCIENTOS', 'TRESCIENTOS', 'CUATROCIENTOS', 'QUINIENTOS', 'SEISCIENTOS', 'SETECIENTOS',
  'OCHOCIENTOS', 'NOVECIENTOS'];

// 0–999
function hundreds(n) {
  if (n === 100) return 'CIEN';
  const h = Math.floor(n / 100); const rest = n % 100;
  const tail = rest < 30 ? UNITS[rest] : `${TENS[Math.floor(rest / 10)]}${rest % 10 ? ` Y ${UNITS[rest % 10]}` : ''}`;
  return [HUNDREDS[h], tail].filter(Boolean).join(' ');
}

function integerWords(n) {
  if (n === 0) return 'CERO';
  const millions = Math.floor(n / 1000000);
  const thousands = Math.floor((n % 1000000) / 1000);
  const rest = n % 1000;
  return [
    millions ? (millions === 1 ? 'UN MILLÓN' : `${integerWords(millions)} MILLONES`) : '',
    thousands ? (thousands === 1 ? 'MIL' : `${hundreds(thousands)} MIL`) : '',
    rest ? hundreds(rest) : '',
  ].filter(Boolean).join(' ');
}

export default function amountInWords(amount) {
  const cents = Math.round(Math.abs(Number(amount) || 0) * 100);
  const pesos = Math.floor(cents / 100);
  // "un millón DE pesos": Spanish adds "de" after a round number of millions only.
  const de = pesos >= 1000000 && pesos % 1000000 === 0 ? ' DE' : '';
  return `${integerWords(pesos)}${de} ${pesos === 1 ? 'PESO' : 'PESOS'} CON ${String(cents % 100).padStart(2, '0')}/100`;
}
